import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/case-studies/ai-based-insurance-plan-finder-solution/page.tsx");
